import { atom } from "recoil";
import { ocPersistAtom } from "./persist-atom";

export const ocRefreshTokenTimestampState = atom({
  key: "refreshTokenTimestamp",
  default: "",
  effects_UNSTABLE: [ocPersistAtom],
});
